import { useEffect, useMemo, useRef } from 'react'

import { type Column, Table } from '../../../../../../components/Table'
import { useInfiniteScroll } from '../../../../../../hooks/useInfiniteScroll'
import { useInfiniteAssetAnalystsQuery } from '../../../../../../services/hooks/assetAnalysts/queries/useAssetAnalystsQuery'
import { type AssetAnalystDomain } from '../../../../../../types/domain/asset-analyst-domain'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'

type Props = {
  filters: FiltersDomain
  columns: Column[]
}

export const TableWithInfiniteScroll = ({ filters, columns }: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)

  const {
    data,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useInfiniteAssetAnalystsQuery(filters)

  const rows = useMemo(() => {
    return (
      data?.pages?.reduce(
        (acc: AssetAnalystDomain[], item: { data: AssetAnalystDomain[] }) => [
          ...acc,
          ...item.data,
        ],
        []
      ) || []
    ).map((assetAnalyst) => ({
      id: assetAnalyst.id,
      fullName: assetAnalyst.fullName,
      asset: assetAnalyst.asset?.fullName,
    }))
  }, [data?.pages])

  useInfiniteScroll(tableContainerRef, hasNextPage, fetchNextPage)

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={rows}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      tableContainerRef={tableContainerRef}
      noContentMessage="Sem registro de analista(s)"
      paginationMode="scroll"
    />
  )
}
